<script setup lang="ts">
  import { defineEmits, defineProps } from 'vue';

  defineProps({
    modelValue: {
      type: String,
      required: true,
    },
    options: {
      type: Array as () => Array<{ key: string; label: string }>,
      required: true,
    },
  });

  const emit = defineEmits(['update:modelValue']);

  const handleChange = (value: string) => {
    emit('update:modelValue', value);
  };
</script>

<template>
  <div class="grid grid-cols-3 gap-3">
    <label
      v-for="option in options"
      :key="option.key"
      class="flex items-center gap-3 cursor-pointer group"
    >
      <span
        class="w-5 h-5 flex justify-center items-center border-2 rounded-full group-hover:border-teal-600 group-focus:ring-2 group-focus:ring-teal-600 transition"
        :class="{
          'border-gray-400': modelValue !== option.key,
          'border-teal-600 bg-teal-600': modelValue === option.key,
        }"
      >
        <span
          class="w-2.5 h-2.5 bg-white dark:border-gray-800 rounded-full"
          v-if="modelValue === option.key"
        ></span>
      </span>
      <span class="text-gray-800 group-hover:text-teal-600">
        {{ option.label }}
      </span>
      <input
        type="radio"
        :value="option.key"
        :checked="modelValue === option.key"
        @change="handleChange(option.key)"
        class="hidden"
      />
    </label>
  </div>
</template>
